module.exports = __webpack_public_path__ + "static/media/EntriesManagementIcon.3ebbf7b0.svg";